<template>
  <div
    class="auth-view"
    data-view="forgot"
  >
    <div v-if="stage === 'form'">
      <button
        type="button"
        class="back-link"
        @click="$emit('switch-mode', 'login')"
      >
        {{ t('forgot_back') }}
      </button>
      <h2>
        {{ t('forgot_title_prefix') }}<span class="grad">{{ t('forgot_title_grad') }}</span
        >{{ t('forgot_title_suffix') }}
      </h2>
      <p class="sub">{{ t('forgot_sub') }}</p>

      <div class="signup-field">
        <label
          class="field-label"
          id="forgot-email-label"
          >{{ t('lbl_email') }}</label
        >
        <input
          id="forgot-email"
          v-model="email"
          type="email"
          class="signup-input"
          aria-labelledby="forgot-email-label"
          :placeholder="t('ph_email')"
          inputmode="email"
          autocomplete="email"
        />
      </div>

      <div
        v-if="submitError"
        class="submit-err show"
      >
        <icon-info-circle
          :size="16"
          :stroke-width="2.4"
        />
        <span>{{ submitError }}</span>
      </div>

      <button
        type="button"
        class="sb-next wide"
        :disabled="submitting"
        @click="submit"
      >
        <template v-if="submitting">
          <span
            class="spinner"
            aria-hidden="true"
          ></span>
          {{ t('btn_loading') }}
        </template>
        <template v-else>{{ t('forgot_btn') }} <span>→</span></template>
      </button>
    </div>

    <div
      v-else
      class="auth-confirm"
    >
      <div class="icon success">
        <icon-mail
          :size="42"
          :stroke-width="2.3"
        />
      </div>
      <h2>
        {{ t('forgot_sent_title_prefix')
        }}<span class="grad">{{ t('forgot_sent_title_grad') }}</span
        >{{ t('forgot_sent_title_suffix') }}
      </h2>
      <p>{{ t('forgot_sent_body') }}</p>
      <button
        type="button"
        class="sb-next wide"
        @click="$emit('switch-mode', 'login')"
      >
        {{ t('forgot_back') }}
      </button>
    </div>
  </div>
</template>

<script>
import { i18nMixin, refreshCsrfToken, EMAIL_RE } from './helpers';
import IconInfoCircle from '../icons/IconInfoCircle.vue';
import IconMail from '../icons/IconMail.vue';

export default {
  name: 'ForgotPasswordForm',
  mixins: [i18nMixin],
  components: { IconInfoCircle, IconMail },
  props: {
    // Lets the parent pre-fill the email — used when LoginForm bounces a
    // USER_SELF_DELETE failure into this form so the user doesn't retype it.
    initialEmail: { type: String, default: '' },
  },
  data() {
    return {
      stage: 'form', // 'form' | 'sent'
      email: this.initialEmail || '',
      submitError: '',
      submitting: false,
    };
  },
  methods: {
    async submit() {
      this.submitError = '';
      const email = (this.email || '').trim();
      if (!EMAIL_RE.test(email)) {
        this.submitError = this.t('err_email_invalid');
        return;
      }
      this.submitting = true;
      this.$emit('submitting', true);
      await refreshCsrfToken();
      try {
        // Backend's SendPasswordResetTrait reads `input('login')` (not `email`)
        // and decides email-vs-phone reset based on its content. Sending the
        // wrong key makes the controller pick the phone branch and quietly 422.
        await axios.post(zRoute('password.token'), { login: email });
        // Anti-enumeration: always show "check your inbox" regardless of
        // whether the address is registered.
        this.stage = 'sent';
      } catch (e) {
        this.stage = 'sent';
      } finally {
        this.submitting = false;
        this.$emit('submitting', false);
      }
    },
  },
};
</script>
